import { Component, ViewEncapsulation, output } from '@angular/core';
import { LayMenFooterComponent } from './lay-men-footer/lay-men-footer.component';
import { LayMenHeaderComponent } from './lay-men-header/lay-men-header.component';
import { LayMenMenuComponent } from './lay-men-menu/lay-men-menu.component';

@Component({
    selector: 'lay-menu',
    templateUrl: './lay-menu.component.html',
    styleUrls: ['./lay-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [LayMenHeaderComponent, LayMenMenuComponent, LayMenFooterComponent],
})
export class LayMenuComponent {
    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    readonly onMenuSizeChange = output<boolean>();

    public isMin = false;

    minMenu(value: boolean): void {
        this.isMin = value;
        this.onMenuSizeChange.emit(this.isMin);
    }
}
